function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useObservableEagerState } from 'observable-hooks';
import { useLocation } from 'react-router-dom';
import { InjectableContexts } from '../enums';
import { useCommonTrackData } from '../hooks/use-common-track-data';
import { useDocumentTitle } from '../hooks/use-document-title';
import { useAuthService } from '../hooks/use-services';
import { useWindowedObservable } from '../hooks/use-windowed-observable';
import { capitalize } from '../util';
import { WindowedObservable } from '../windowed-observable';
var TrackingContext = /*#__PURE__*/ createContext({});
export var generateUniqueID = function(userId, firstName, lastName) {
    return "".concat(userId, " - ").concat(firstName, " ").concat(lastName);
};
export var TrackingProvider = function(param) {
    var children = param.children, token = param.token, _param_pageTitlePrefix = param.pageTitlePrefix, pageTitlePrefix = _param_pageTitlePrefix === void 0 ? null : _param_pageTitlePrefix;
    var authService = useAuthService();
    var location = useLocation();
    var _useState = _sliced_to_array(useState(false), 2), panelLoaded = _useState[0], setPanelLoaded = _useState[1];
    var commonProperties = useCommonTrackData();
    var currentUser = useObservableEagerState(authService.currentUser$);
    // Mixpanel Configuration
    useEffect(function() {
        try {
            mixpanel.init(token, {
                persistence: 'localStorage'
            });
            if (currentUser) {
                var id = currentUser.id, firstName = currentUser.firstName, lastName = currentUser.lastName, email = currentUser.email;
                var uniqueID = generateUniqueID(id, firstName, lastName);
                mixpanel.identify(uniqueID);
                // default properties
                mixpanel.register(_object_spread({
                    $distinct_id: uniqueID
                }, commonProperties));
                // register user with mixpanel
                mixpanel.people.set({
                    userId: id,
                    $distinct_id: uniqueID,
                    $email: email,
                    $first_name: firstName,
                    $last_name: lastName
                });
            }
            setPanelLoaded(true);
        } catch (error) {
        /* empty */ }
    }, [
        commonProperties,
        currentUser,
        token
    ]);
    // Track Events
    var track = useCallback(function(event) {
        var name = event.name, properties = event.properties;
        try {
            mixpanel.track(name, properties);
        } catch (error) {
        /* empty */ }
    }, []);
    var setTitle = useDocumentTitle().setTitle;
    // Track PageViews
    useEffect(function() {
        if (panelLoaded) {
            try {
                var _location_pathname, _capitalize_trim, _capitalize;
                var locationPathName = location === null || location === void 0 ? void 0 : (_location_pathname = location.pathname) === null || _location_pathname === void 0 ? void 0 : _location_pathname.split('/')[1];
                var pageTitle = (_capitalize = capitalize(locationPathName)) === null || _capitalize === void 0 ? void 0 : (_capitalize_trim = _capitalize.trim()) === null || _capitalize_trim === void 0 ? void 0 : _capitalize_trim.replace(/-/g, ' ');
                if (pageTitlePrefix) {
                    pageTitle = "".concat(pageTitlePrefix, " - ").concat(pageTitle);
                }
                setTitle(pageTitle);
                mixpanel.track_pageview();
            } catch (err) {
            /* empty */ }
        }
    }, [
        location,
        panelLoaded,
        setTitle
    ]);
    // Click Tracking
    var handleClickEvent = useCallback(function(event) {
        try {
            var link = event.target.closest("a");
            if (link) {
                mixpanel.track('Click Tracking', {
                    text: link.ariaLabel ? link.ariaLabel : link.textContent,
                    type: 'Link'
                });
            }
            var button = event.target.closest("button");
            if (button) {
                if (button.textContent) {
                    var payload = {
                        text: button.textContent,
                        type: 'Button'
                    };
                    if (button.name) {
                        payload = _object_spread_props(_object_spread({}, payload), {
                            trackingEventName: button.name
                        });
                    }
                    mixpanel.track('Click Tracking', payload);
                } else if (button.ariaLabel) {
                // Icon Button
                }
            }
            var listItem = event.target.closest("li");
            if (listItem) {
                mixpanel.track('Click Tracking', {
                    text: listItem.textContent,
                    type: 'MenuItem'
                });
            }
        } catch (error) {
        /* empty */ }
    }, []);
    useEffect(function() {
        document.addEventListener('click', handleClickEvent);
        return function() {
            document.removeEventListener('click', handleClickEvent);
        };
    }, [
        handleClickEvent
    ]);
    useEffect(function() {
        new WindowedObservable(InjectableContexts.MixPanelTracking).publish(TrackingContext);
    }, []);
    var mixPanelTrack = useMemo(function() {
        return {
            track: track
        };
    }, [
        track
    ]);
    return /*#__PURE__*/ _jsx(TrackingContext.Provider, {
        value: mixPanelTrack,
        children: children
    });
};
export var useMixPanelTracking = function() {
    var context = useWindowedObservable(InjectableContexts.MixPanelTracking);
    return useContext(context !== null && context !== void 0 ? context : TrackingContext);
};
